<div class="row justify-content-between align-items-end">
  <div class="col mb-4 mb-sm-0">
    <p class="text-muted m-0 ps-1 border-start border-5 border-primary-subtle">
      Намерени: <strong>{{ totalResults }}</strong>
    </p>
  </div>
  <div class="col-12 col-sm-6 col-xl-4">
    <ng-select
      [clearable]="false"
      [searchable]="false"
      [items]="sortOptions"
      bindValue="id"
      bindLabel="name"
      placeholder="Сортирай по"
      notFoundText="Няма намерени"
      [inputAttrs]="{ name: 'search-sort-type' }"
      [(ngModel)]="selectedSortOption"
      (ngModelChange)="onSortOptionChange.emit($event)">
    </ng-select>
  </div>
</div>
